<div class="d-flex p-3">
  <bdg-text-avatar [text]="userInfo?.name"></bdg-text-avatar>
  <div class="ml-2 d-flex flex-column">
    <span class="mat-subheading-1 info-user-name mb-1 overflow-hidden">{{ userInfo.name }}</span>
    <span class="mat-body-1 info-user-color mb-1">{{ userInfo.role }}</span>
    <span
      *ngIf="!isDegts && !isFinanceiro && !isTransferencia && !isAdministrador"
      class="mat-caption info-user-hospital info-user-color overflow-hidden"
      >{{ userInfo.hospital }}</span
    >
  </div>
</div>
